<template>
  <div
    v-loading.lock="loading"
    :element-loading-text="$t('connecting')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="py-2.5 px-4 rounded-20 flex items-center gap-2 justify-between overflow-hidden"
    @click="$emit('click')"
  >
    <div class="overflow-hidden">
      <h1 class="text-32 leading-snug font-bold">
        {{ formatNumber(animatedCount) }}
      </h1>
      <p class="text-lg leading-snug font-bold">{{ title }}</p>
    </div>
    <div>
      <slot>
        <div class="w-25 h-25">
          <img class="w-full h-full object-contain" :src="img" alt="building" />
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    img: {
      type: String,
      default() {
        return require("@/assets/img/icons/building.svg");
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      animatedCount: 0,
    };
  },
  watch: {
    count: {
      handler(newVal) {
        if (!this.loading) {
          if (this.animated) {
            this.animateToCount(newVal);
          } else {
            this.animatedCount = parseInt(newVal) || 0;
          }
        }
      },
      immediate: true,
    },
    loading: {
      handler(newVal) {
        if (!newVal && this.count) {
          // Loading tugaganda animatsiya boshlash
          if (this.animated) {
            this.animateToCount(this.count);
          } else {
            this.animatedCount = parseInt(this.count) || 0;
          }
        }
      },
    },
  },
  methods: {
    animateToCount(targetValue) {
      const target = parseInt(targetValue) || 0;
      const startValue = 0; // Doimo 0 dan boshlash
      const duration = 2000; // 2 soniya
      const startTime = Date.now();

      const animate = () => {
        const currentTime = Date.now();
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function (ease-out)
        const easeOut = 1 - Math.pow(1 - progress, 3);

        this.animatedCount = Math.floor(
          startValue + (target - startValue) * easeOut
        );

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.animatedCount = target;
        }
      };

      animate();
    },
    formatNumber(num) {
      if (!num) return "0";
      // Raqamga aylantirish
      const number = parseInt(num);
      if (isNaN(number)) return num;

      // 3 xonadan bo'lib, bo'shliq bilan ajratish
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped></style>
